export default __webpack_public_path__ + "static/media/login-image.d0eab8b2.svg";